import { makeStyles } from '@material-ui/core/styles';

export const colors = {
  purplePrimary: '#7D33B6',
  purpleLight: '#F5F0FF',
  purpleIconBg: '#E0D1FA',
  textPrimary: '#21212E',
  textSecondary: '#61616B',
  borderDefault: '#D1D1D6',
};

export const useOtpSendStyles = makeStyles((theme) => ({
  subtitle: {
    color: colors.textSecondary,
    fontSize: 13,
    lineHeight: '16px',
    marginBottom: theme.spacing(2),
  },
  optionCard: {
    alignItems: 'center',
    border: `1px solid ${colors.borderDefault}`,
    borderRadius: 4,
    cursor: 'pointer',
    display: 'flex',
    gap: 12,
    marginBottom: theme.spacing(1.5),
    padding: 14,
    width: '100%',
    '&:hover:not($optionCardDisabled)': {
      boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
    },
    '&:focus': {
      outline: `2px solid ${colors.purplePrimary}`,
      outlineOffset: 2,
    },
  },
  optionCardSelected: {
    backgroundColor: colors.purpleLight,
    border: `2px solid ${colors.purplePrimary}`,
  },
  optionCardDisabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
  radioOuter: {
    border: `2px solid ${colors.borderDefault}`,
    borderRadius: '50%',
    flexShrink: 0,
    height: 18,
    width: 18,
  },
  radioOuterSelected: {
    backgroundColor: colors.purplePrimary,
    borderColor: colors.purplePrimary,
  },
  optionLabel: {
    color: colors.textPrimary,
    fontSize: 13,
    fontWeight: 500,
  },
  optionValue: {
    color: colors.textSecondary,
    fontSize: 12,
  },
  confirmCard: {
    alignItems: 'center',
    backgroundColor: colors.purpleLight,
    border: `2px solid ${colors.purplePrimary}`,
    borderRadius: 6,
    display: 'flex',
    gap: 14,
    padding: 16,
    width: '100%',
  },
  iconCircle: {
    alignItems: 'center',
    backgroundColor: colors.purpleIconBg,
    borderRadius: '50%',
    display: 'flex',
    height: 40,
    justifyContent: 'center',
    width: 40,
  },
  checkCircle: {
    alignItems: 'center',
    backgroundColor: colors.purplePrimary,
    borderRadius: '50%',
    color: '#fff',
    display: 'flex',
    height: 24,
    justifyContent: 'center',
    width: 24,
  },
  confirmLabel: {
    color: colors.purplePrimary,
    fontSize: 13,
    fontWeight: 600,
  },
  errorAlert: {
    marginBottom: theme.spacing(2),
  },
}));
